import React from 'react';
import { CheckIcon } from 'lucide-react';
import { worrySigns } from '../data/content';
export function ChildRecognition() {
  return <section className="bg-dusty-wash py-12 lg:py-20" data-id="element-29" data-mp="d3xgjws9x116">
      <div className="mx-auto grid max-w-content gap-8 px-5 sm:px-8 lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)] lg:gap-16" data-id="element-30" data-mp="hvowlddszod2">
        <div data-id="element-31" data-mp="mu06tp80g0vt">
          <p className="text-[12px] font-semibold uppercase tracking-[0.2em] text-dusty-deep" data-id="element-32" data-mp="murywq2efghc">When worry doesn’t look like worry</p>
          <h2 className="mt-4 text-balance font-display text-[31px] leading-[1.1] text-ink sm:text-[42px] lg:text-[48px]" data-id="element-33" data-mp="3qc0ipfgosqep">
            Maybe You’ve Been Seeing It Already
          </h2>
          <p className="mt-4 text-[17px] leading-relaxed text-ink-soft" data-id="element-34" data-mp="3vd7nd5nj99h5">
            Worry doesn’t always sound like: <span className="font-display italic text-ink" data-id="element-35" data-mp="34zkm8siq585">“Mom, I’m anxious.”</span>
          </p>
          <p className="mt-1 text-[17px] leading-relaxed text-ink-soft" data-id="element-36" data-mp="1an8ij51sbgir">Sometimes it looks more like:</p>
        </div>

        <ul className="divide-y divide-dusty/70 self-center border-y border-dusty/70" data-id="element-37" data-mp="18lgnykey9cl2">
          {worrySigns.map(sign => <li key={sign} className="flex items-center gap-3.5 py-3.5 sm:py-4" data-id="element-38" data-mp="13nnm23koj4ql">
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-paper text-dusty-deep" aria-hidden="true" data-id="element-39" data-mp="ymzrx915m7s5">
                <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} data-id="element-40" data-mp="ulo1x2edbkjf" />
              </span>
              <span className="text-[16px] leading-snug text-ink sm:text-[18px]" data-id="element-41" data-mp="pofhsw9nt6fj">{sign}</span>
            </li>)}
        </ul>

        <div className="text-center lg:col-span-2" data-id="element-42" data-mp="kub8w7gu2obt">
          <p className="text-[17px] leading-relaxed text-ink-soft" data-id="element-43" data-mp="fxt8fjsjdc5a">
            And when you see your child struggling, your instinct makes complete sense:
          </p>
          <p className="mt-2 font-display text-[24px] leading-snug text-ink sm:text-[28px]" data-id="element-44" data-mp="6wv1otqpqqj0">You try to make them feel safe.</p>
        </div>
      </div>
    </section>;
}